module["exports"] = [
  "Україна"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/default_country.js
// module id = 1609
// module chunks = 1